<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          :color="enterpriseColor"
          v-bind="attrs"
          v-on="on"
          x-large
        >
          mdi-qrcode
        </v-icon>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <v-icon>mdi-qrcode</v-icon>QR
        </v-card-title>

        <v-card-text>
          <v-img
            v-show="false"
            v-if="qrImage && qrImage.length > 0"
            :src="qrImage"
            :lazy-src="qrImage"
            aspect-ratio="1"
            class="grey lighten-2"
            width="100%"
            height="auto"
          />
          <div v-if="svg" v-html="svg" />
          <center>
            <a
              v-if="item.URL && item.URL.length > 0"
              :href="item.URL"
              style="font-size: 20px;"
            >
              {{ item.URL }}
            </a>
          </center>
          <br />
          <center><a href="#" @click="downloadSVG" class="link-download btn btn-primary btn-sm">{{ $t('share.downloadSVG') }}</a></center>
          <center><a
            :download="`qr.png`" 
            v-if="qrImage && qrImage.length > 0"
            :href="qrImage"
            >{{ $t('share.downloadPNG') }}
          </a></center>
          <br />
        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            {{ $t('common.close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcode'
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    enterpriseColor: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    qrImage: '',
    svg: null
  }),
  mounted () {
    this.handleCreateQR()
  },
  methods: {
    handleCreateQR () {
      QRCode.toDataURL(this.item.URL, {
        type: 'image/png',
        width: 344,
        color: {
          dark: '#000000',  // Blue dots
          light: '#FFFFFF'
        }
      })
      .then(url => {
        this.qrImage = url
      })
      .catch(err => {
        console.error(err)
      })

      QRCode.toString(this.item.URL, {
        type: 'image/svg',
        color: {
          dark: '#000',
          light: 'red'
        }
      })
      .then(url => {
        this.svg = url.replace('<svg', '<svg id="dynamicIllustration" ')
      })
      .catch(err => {
        console.error(err)
      })
    },
    downloadSVG(evt) {

      // document.querySelector(".link-download").addEventListener("click", (evt) => {
      const svgContent = document.getElementById("dynamicIllustration").outerHTML,
        blob = new Blob([svgContent], {
          type: "image/svg+xml"
        }),
        url = window.URL.createObjectURL(blob),
        link = evt.target

      link.target = "_blank"
      link.download = `qr.svg`
      link.href = url
    },
  }
}
</script>

